export const menuList = [
  {
    menuId: 'HOME',
    menuName: 'Home',
    menuDesc: '',
    menuSeq: 1,
    icon: 'home',
    createUser: '',
    createDate: '2026-03-06 13:47:58.000',
    updateUser: '',
    updateDate: '',
  },
  {
    menuId: 'DASHBOARD',
    menuName: 'Dashboard',
    menuDesc: '',
    menuSeq: 2,
    icon: 'dashboard',
    createUser: '',
    createDate: '2026-03-06 13:47:58.000',
    updateUser: '',
    updateDate: '',
  },
  {
    menuId: 'MONITORING',
    menuName: 'Monitoring',
    menuDesc: '',
    menuSeq: 3,
    icon: 'monitoring',
    createUser: '',
    createDate: '2026-03-06 13:47:58.000',
    updateUser: '',
    updateDate: '',
  },
  {
    menuId: 'PROJECT',
    menuName: 'Projects',
    menuDesc: '',
    menuSeq: 4,
    icon: 'project',
    createUser: '',
    createDate: '2026-03-06 13:47:58.000',
    updateUser: '',
    updateDate: '',
  },
  {
    menuId: 'EXPLORER',
    menuName: 'Explorer',
    menuDesc: '',
    menuSeq: 5,
    icon: 'explorer',
    createUser: '',
    createDate: '2026-03-06 13:47:58.000',
    updateUser: '',
    updateDate: '',
  },
  {
    menuId: 'WORKSPACE',
    menuName: 'Workspace',
    menuDesc: '',
    menuSeq: 6,
    icon: 'workspace',
    createUser: '',
    createDate: '2026-03-06 13:47:58.000',
    updateUser: '',
    updateDate: '',
  },
  {
    menuId: 'ABOUT',
    menuName: 'About',
    menuDesc: '',
    menuSeq: 7,
    icon: 'about',
    createUser: '',
    createDate: '2026-03-06 13:47:58.000',
    updateUser: '',
    updateDate: '',
  },
  {
    menuId: 'GUIDE',
    menuName: 'Guide',
    menuDesc: '',
    menuSeq: 8,
    icon: 'guide',
    createUser: '',
    createDate: '2026-03-06 13:47:58.000',
    updateUser: '',
    updateDate: '',
  },
  {
    menuId: 'QNA',
    menuName: 'QnA',
    menuDesc: '',
    menuSeq: 9,
    icon: 'qna',
    createUser: '',
    createDate: '2026-03-06 13:47:58.000',
    updateUser: '',
    updateDate: '',
  },
  {
    menuId: 'MANAGEMENT',
    menuName: 'Management',
    menuDesc: '',
    menuSeq: 10,
    icon: 'management',
    createUser: '',
    createDate: '2026-03-06 13:47:58.000',
    updateUser: '',
    updateDate: '',
  },
]
